import { connect } from 'react-redux';

import { getPermissions } from '../Login/selectors';
import {
  generateDailyQuizForTodayAction,
  getAllDailyQuizForTodayAction,
} from './actionSagas';
import DailyQuiz from './DailyQuiz';
import { getAllDailyQuiz } from './selectors';

const mapStateToProps = (state) => ({
  allDailyQuiz: getAllDailyQuiz(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllDailyQuizForToday: () => dispatch(getAllDailyQuizForTodayAction()),
  generateDailyQuizForToday: () => dispatch(generateDailyQuizForTodayAction()),
});

const DailyQuizContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DailyQuiz);

export default DailyQuizContainer;
